import React from "react";

const SettingsView = () => <h1 className="m-5">Settings</h1>;

export default SettingsView;
